import { useState } from 'react';
import Button from '../UI/Button/Button';
import styles from './ApplicantForm.module.css';
import cn from 'classnames';
import { sendLeadToWhatsApp } from '../../utils/whatsapp';

export default function ApplicantForm() {
  const [isSent, setIsSent] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: boolean }>({});

  const validate = (data: { [key: string]: string }) => {
    const newErrors: { [key: string]: boolean } = {};

    if (!data.fullName || data.fullName.trim() === '') {
      newErrors.fullName = true;
    }

    if (!data.phoneNumber || data.phoneNumber.trim() === '') {
      newErrors.phoneNumber = true;
    }

    if (!data.email || data.email.trim() === '') {
      newErrors.email = true;
    }

    if (!data.more || data.more.trim() === '') {
      newErrors.more = true;
    }

    return newErrors;
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    const data = Object.fromEntries(formData.entries()) as { [key: string]: string };
    const validationErrors = validate(data);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      sendLeadToWhatsApp({
        title: 'Анкета соискателя',
        fields: [
          { label: 'Имя и фамилия', value: data.fullName },
          { label: 'Телефон', value: data.phoneNumber },
          { label: 'Email', value: data.email },
          { label: 'О себе', value: data.more },
        ],
      });
      setIsSent(true);
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const validEmail = e.target.value.replace(/[^a-zA-Z0-9@.\-_]/g, '');
    e.target.value = validEmail;
  };

  const formatPhoneNumber = (value: string) => {
    const digits = value.replace(/\D/g, '');

    if (digits === '' || digits === '+') {
      return '+7 ';
    }

    let formatted = '+7';

    if (digits.length > 1) {
      formatted += ` ${digits.slice(1, 4)}`;
    }
    if (digits.length > 4) {
      formatted += ` ${digits.slice(4, 7)}`;
    }
    if (digits.length > 7) {
      formatted += `-${digits.slice(7, 9)}`;
    }
    if (digits.length > 9) {
      formatted += `-${digits.slice(9, 11)}`;
    }

    return formatted;
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatPhoneNumber(e.target.value);
    e.target.value = formattedValue;
  };

  const handlePhoneFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    if (!e.target.value.startsWith('+7')) {
      e.target.value = '+7';
    }
  };

  const handlePhoneBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (e.target.value === '+7 ' || e.target.value === '+7') {
      e.target.value = '';
    }
  };

  const getInputClassName = (fieldName: string) =>
    cn('text-3-bold_font', styles.form_field, errors[fieldName] && styles.error_field);

  return (
    <div className={styles.applicant_form}>
      {isSent ? (
        <div className={styles.success}>
          <h4>Спасибо!</h4>
          <p className={cn('text-2_font', styles.success_text)}>
            Обычно мы рассматриваем заявки в течение 2-х недель. Если вы не получили, попробуйте
            подать резюме на другую подходящую вакансию
          </p>
        </div>
      ) : (
        <>
          <h4>Анкета соискателя</h4>
          <form className={styles.applicant_form_wrapper} onSubmit={handleSubmit}>
            <div className={styles.top}>
              <div className={styles.left_col}>
                <div>
                  <label htmlFor='fullName'>
                    <input
                      className={getInputClassName('fullName')}
                      name='fullName'
                      id='fullName'
                      type='text'
                      placeholder='Имя и фамилия'
                    />
                  </label>
                </div>
                <div>
                  <label htmlFor='phoneNumber'>
                    <input
                      className={getInputClassName('phoneNumber')}
                      name='phoneNumber'
                      id='phoneNumber'
                      type='text'
                      placeholder='Телефон'
                      onFocus={handlePhoneFocus}
                      onChange={handlePhoneChange}
                      onBlur={handlePhoneBlur}
                    />
                  </label>
                </div>
                <div>
                  <label htmlFor='email'>
                    <input
                      className={getInputClassName('email')}
                      name='email'
                      id='email'
                      type='text'
                      placeholder='Почта'
                      onChange={handleEmailChange}
                    />
                  </label>
                </div>
              </div>
              <div className={styles.right_col}>
                <label htmlFor='more'>
                  <textarea
                    className={getInputClassName('more')}
                    name='more'
                    id='more'
                    placeholder='О себе или ссылку на резюме'
                  ></textarea>
                </label>
              </div>
            </div>
            <Button colorType='blue' roundType='small_rounded' type='submit'>
              Откликнуться
            </Button>
          </form>
        </>
      )}
    </div>
  );
}
